import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography, Paper, Box } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { PRIMARY_COLOR } from "styles/themes/overrides";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "70vh",
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(6),
    textAlign: "center",
    maxWidth: 600,
  },
  icon: {
    fontSize: 80,
    color: PRIMARY_COLOR,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  message: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
}));

const getProductSuiteFromPath = (pathname: string): string | null => {
  if (
    pathname.startsWith("/catalog") ||
    pathname.startsWith("/business-rules")
  ) {
    return "Catalog";
  }
  if (pathname.startsWith("/performance")) {
    return "Analytics";
  }
  return null;
};

const PermissionDenied: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const productSuite = getProductSuiteFromPath(location.pathname);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={2}>
        <LockIcon className={classes.icon} />
        <Typography variant="h5" className={classes.title}>
          <FormattedMessage
            id="permissionDenied.title"
            defaultMessage="Access Denied"
          />
        </Typography>
        <Typography variant="body1" className={classes.message}>
          {productSuite ? (
            <FormattedMessage
              id="permissionDenied.messageWithSuite"
              defaultMessage="You don't have permission to access the {productSuite} product suite."
              values={{ productSuite }}
            />
          ) : (
            <FormattedMessage
              id="permissionDenied.message"
              defaultMessage="You don't have permission to access this feature."
            />
          )}
        </Typography>
        <Box>
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage
              id="permissionDenied.contactSupport"
              defaultMessage="Please contact Smart Merchandiser Support for further assistance."
            />
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default PermissionDenied;
